/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Stitch Web
 * OpenAPI spec version: 0.0.53
 */

export type EncounterListItemCloseReason =
	(typeof EncounterListItemCloseReason)[keyof typeof EncounterListItemCloseReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EncounterListItemCloseReason = {
	superseded_by_visit_note: 'superseded_by_visit_note',
	superseded_by_reopen: 'superseded_by_reopen',
	abandoned: 'abandoned',
	finalization_failed: 'finalization_failed',
	manual: 'manual',
} as const;
